import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface IRelative {
  id: number
  code: string
  title: string
  status: number
}
export interface IRelativeEdit {
  id: number
  code: string
  title: string
  status: number
}
// danh sách mối quan hệ khách hàng
export const gListRelative = async (limit?: number, pageNumber?: number, search?: string) => {
  const path = "relatives/listRelatives"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<IRelative[]> = await axiosClient.get(
    path, { params }
  )
  return result
};

// thông tin mối quan hệ
export const gInfoRelative = async (id: number) => {
  const path = "relatives/infoRelative"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IRelativeEdit> = await axiosClient.get(
    path, { params }
  )
  return result
}
export const addRelative = async (code: string, title: string, status: number) => {
  const path = "relatives/addRelative"
  const params = {
   code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  )
  return result
}
export const editRelative = async (id: number, code: string, title: string, status: number) => {
  const path = "relatives/editRelative"
  const params = {
    id,code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
export const deleteRelative = async (id: number) => {
  const path = "relatives/deleteRelative"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  )
  return result
}
export const updateStatusRelative = async (id: number) => {
  const path = "relatives/activeRelative"

  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
